/**
 * FHIR Export Utilities
 * Helper functions for downloading FHIR exports
 */

/**
 * Triggers a file download with the given content
 * @param content - The file content (JSON string)
 * @param filename - The filename for the download
 */
export function downloadFile(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'application/fhir+json;charset=utf-8' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  // Clean up the object URL after a short delay
  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 100)
}

/**
 * Generates a filename for FHIR export
 * @param patientId - The patient ID
 * @param maskPII - Whether PII is masked
 * @returns The generated filename
 */
export function generateFHIRFilename(patientId: string, maskPII: boolean): string {
  const timestamp = new Date().toISOString().split('T')[0]
  const suffix = maskPII ? 'masked' : 'full'
  return `patient_${patientId}_fhir_${suffix}_${timestamp}.json`
}




